export default function modal(state = {}, action) {
    switch (action.type) {
    case 'SET_MODAL':
        return { ...state, type: action.name, header: action.header, msg: action.msg, vars: action.vars };
    default:
        return state;
    }
}



// WEBPACK FOOTER //
// ./src/_app/quick_response/reducers/modal_reducers.js